import { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";

import api from "api/api";
import { useNavigate } from "react-router-dom";

// import { styled } from "@mui/material/styles";

// import Mui components
import { useTheme } from "@mui/material/styles";
import Button from "@mui/material/Button";
// import Box from "@mui/material/Box";
// import ClickAwayListener from "@mui/material/ClickAwayListener";
import CircularProgress from "@mui/material/CircularProgress";
import Switch from "@mui/material/Switch";

import Checkbox from "@mui/material/Checkbox";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
// import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
// import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import IconButton from "@mui/material/IconButton";

import Box from "@mui/material/Box";

// import mui icons
import AnalyticsIcon from "@mui/icons-material/Analytics";
import CloseIcon from "@mui/icons-material/Close";
import NotificationsIcon from "@mui/icons-material/Notifications"; // Import Bell icon
// import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

//import components
import ProductDetails from "../common/ProductDetails";
import ProductWithTestCode from "../common/ProductWithTestCode";
// import ConsumerFilter from "../common/ConsumerFilter";

// import assets
import WeightToggleIcon from "../../assets/icons/weightToggle.png";

// redux
import { useSelector, useDispatch } from "react-redux";
import { loadProductOrderState } from "store/features/productsInfoSlice";
import { loadCorrelationRemovedKpiListState } from "store/features/analysisKpiSlice";
import { loadWeightToggleForCorrelationState } from "store/features/correlationSlice";
import { showNotification } from "store/features/notificationSlice";

// import SampleSize from "../common/SampleSize";
import SampleSizeNew from "../common/SampleSizeNew";
// import WeightToggleComponent from "components/common/WeightToggleComponent";
import ColumnVisibility from "../common/ColumnVisibility";
import FilterAcrossProductsToggleComponent from "components/common/FilterAcrossProductsToggleComponent";
import Reset from "./Reset";
import SortFinalData from "utils/SortFinalData";
import CorrelationConsumerFilter from "./CorrelationConsumerFilter";
import VariableCategoryColorMap from "../../utils/VariableCategoryColorMap";
import DriverAnalysisFilters from "./DriverAnalysisFilters";

// const LightTooltip = styled(({ className, ...props }) => (
//     <Tooltip
//         {...props}
//         classes={{ popper: className }}
//     />
// ))(({ theme }) => ({
//     [`& .${tooltipClasses.tooltip}`]: {
//         backgroundColor: theme.palette.common.white,
//         color: "rgba(0, 0, 0, 0.87)",
//         //   boxShadow: theme.shadows[1],
//         fontSize: 11,
//     },
// }));

function CorrelationTable({ productsSecondaryData = [], handleFilterSubmit = () => { }, selectedStudy = [], correlationData = [], targetKpi = null, targetKpiLabel = "", targetKpiNan = false, sampleInfo = {}, correlationMethodLabel = "", getDefaultCorrelationMethod = () => { }, resetTargetVariable = () => { } }) {
    const dispatch = useDispatch();
    const theme = useTheme();

    const isConsumerFilterLoadingStoreData = useSelector((state) => state.consumerFilterStore.isLoading);
    const productColumnVisibility = useSelector((state) => state.productsInfoStore.productsVisibility);
    const productsOrder = useSelector((state) => state.productsInfoStore.productsOrder);
    const role = useSelector((state) => state.userStore.role) || null;
    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);
    const weightToggle = useSelector((state) => state.correlationStore.weightToggleForCorrelation || false);
    const consumerFilterStoreData = useSelector((state) => state.correlationStore.currentSelectedFiltersForCorrelation);
    const missingFiltersStoreData = useSelector((state) => state.correlationStore.missingFiltersForCorrelation);

    const [productDetailsDialogueOpen, setProductDetailsDialogueOpen] = useState(false);
    const [selectedProductData, setSelectedProductData] = useState({});
    const [selectedProductImage, setSelectedProductImage] = useState(null);

    const navigate = useNavigate();

    const [selectedBackendVariableForDriverAnalysis, setSelectedBackendVariableForDriverAnalysis] = useState([]);

    const isDeodorants = process.env?.REACT_APP_DEODORANTS?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isOralCare = process.env?.REACT_APP_ORAL_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isSkinCleansing = process.env?.REACT_APP_SKIN_CLEANSING?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isUnileverFragranceHouse = process.env?.REACT_APP_UNILEVER_FRAGRANCE_HOUSE?.toLowerCase() === productCategoryData?.label?.toLowerCase();


    // Check for Hair Care and Skin Care categories using environment variables
    const isSkinCare = process.env?.REACT_APP_SKIN_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isHairCare = process.env?.REACT_APP_HAIR_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isBeautyAndWellbeing = isHairCare || isSkinCare;

    // State for color legend filters
    const [selectedColorRanges, setSelectedColorRanges] = useState({
        veryHighPositive: true, // 0.70 Above
        highPositive: true, // 0.69 to 0.40
        moderatePositive: true, // 0.39 to 0.10
        lowPositive: true, // 0.09 to 0
        lowNegative: true, // -0.01 to -0.4
        moderateNegative: true, // -0.4 to -0.69
        highNegative: true, // Below -0.70
    });

    // Color range
    const colorRanges = [
        { key: "veryHighPositive", label: "0.70 Above", min: 0.7, max: 1, color: "#008651" },
        { key: "highPositive", label: "0.69 to 0.40", min: 0.4, max: 0.69, color: "#A3E1D2" },
        { key: "moderatePositive", label: "0.39 to 0.10", min: 0.1, max: 0.39, color: "#FFE300" },
        { key: "lowPositive", label: "0.09 to 0", min: 0, max: 0.09, color: "#FFA91F" },
        { key: "lowNegative", label: "-0.01 to -0.4", min: -0.4, max: -0.01, color: "#FF9998" },
        { key: "moderateNegative", label: "-0.4 to -0.69", min: -0.69, max: -0.4, color: "#FF544F" },
        { key: "highNegative", label: "Below -0.70", min: -1, max: -0.7, color: "#EB0000" },
    ];

    // const resetSelectedBackendVariables = () => {
    //     setSelectedBackendVariableForDriverAnalysis([]); // Reset the selected backend variables
    //     // onResetSelectedBackendVariables(); // Call the prop function if needed
    // };

    // Reset the selectedBackendVariableForDriverAnalysis when resetCorrelation is called
    useEffect(() => {
        // resetSelectedBackendVariables(); // Call the reset function from props
        setSelectedBackendVariableForDriverAnalysis([]);
    }, []); // This effect will run whenever resetCorrelation changes

    // column drag and drop variables
    const [draggableColumns, setDraggableColumns] = useState(productsSecondaryData);
    const [draggedColumnIndex, setDraggedColumnIndex] = useState(null);
    const [draggedColumnDiamension, setDraggedColumnDiamension] = useState({ width: null, height: null });
    const [targetColumnIndex, setTargetColumnIndex] = useState(null);

    const [isDragging, setIsDragging] = useState(false);
    const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
    const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
    const [hasActuallyMoved, setHasActuallyMoved] = useState(false);

    const tableRef = useRef(null);
    const draggedElementRef = useRef(null);
    const initialMousePos = useRef(null);

    const [showCheckBox, setShowCheckBox] = useState(false);
    const [openRestoreDialog, setOpenRestoreDialog] = useState(false);
    const removedList = useSelector((state) => state.analysisKpiStore.correlationRemovedKpiList);
    const [removedKpi, setRemovedKpi] = useState(removedList);
    const [reStoreKpi, setRestoreKpi] = useState([]);
    const [restoreDisabled, setRestoreDisabled] = useState(removedList.length > 0 ? false : true);
    const [disableSubmitButton, setDisableSubmitButton] = useState(true);
    const [selectAllRestore, setSelectAllRestore] = useState(false);

    // const [totalSamplesize, setTotalSampleSize] = useState(0);
    // const [overallColor, setOverallColor] = useState("#000000");
    // const [overallMsg, setOverallMsg] = useState("");
    // let noOfProducts = productsSecondaryData.length;

    useEffect(() => {
        if (removedList.length === 0) {
            setRemovedKpi([]);
            setRestoreDisabled(true);
        }
    }, [removedList]);

    // Clear the removed KPI data from the Redux store on page change to reset the default view.
    // Remove the code below if you want to retain the removed variables.
    useEffect(() => {
        return () => {
            dispatch(loadCorrelationRemovedKpiListState([]));
        };
    }, [dispatch]);

    // updating the order once data loads
    useEffect(() => {
        setDraggableColumns(SortFinalData(productsSecondaryData, productsOrder));
    }, [productsSecondaryData, productsOrder]);

    // useEffect(() => {
    //     if (draggableColumns.length > 0) {
    //         let total = 0;
    //         draggableColumns.forEach((datum) => {
    //             const sampleSize = datum.sampleSize;
    //             if (!productColumnVisibility[`checked--${datum.title.split(" ").join("_")}__${datum.coreDataId}`]) {
    //                 total += sampleSize;
    //             }
    //         });

    //         if (total <= 30) {
    //             setOverallColor("#FF0000");
    //             setOverallMsg("Sample size is below 30");
    //         } else if (total > 30 && total <= 50) {
    //             setOverallColor("#ffa500");
    //             setOverallMsg("The sample size falls between 31 and 50");
    //         } else {
    //             setOverallColor("#000000");
    //             setOverallMsg("");
    //         }

    //         setTotalSampleSize(total);
    //     }
    // }, [draggableColumns, productColumnVisibility]);

    // useEffect(() => {
    //     if (correlationData && correlationData.length > 0) {
    //         const updatedDisabledCheckboxes = disabledCheckboxes;

    //         correlationData.forEach((rowData) => {
    //             if (selectedStudy.length > 1 && rowData.isConsumerFilter === 0) {
    //                 if (rowData.isConsumerFilter === 0) {
    //                     rowData.products.forEach((item) => {
    //                         item.values.forEach((val) => {
    //                             if (val === "NA") {
    //                                 updatedDisabledCheckboxes[rowData.backendVariable] = true;
    //                             }
    //                         });
    //                     });
    //                 }
    //             }
    //         });

    //         setDisabledCheckboxes(updatedDisabledCheckboxes);
    //     }
    // }, [correlationData, selectedStudy]);

    useEffect(() => {
        setSelectedBackendVariableForDriverAnalysis([]);
    }, [targetKpi]);

    const handleWeightToggleChange = () => {
        dispatch(loadWeightToggleForCorrelationState(!weightToggle));
        handleFilterSubmit(null, consumerFilterStoreData, missingFiltersStoreData, !weightToggle);
    };

    const handleCheckboxChange = (chkBox, id) => {
        if (selectedBackendVariableForDriverAnalysis.includes(id)) {
            setSelectedBackendVariableForDriverAnalysis((prevItems) => prevItems.filter((item) => item !== id));
        } else {
            setSelectedBackendVariableForDriverAnalysis((prevItems) => [...prevItems, id]);
        }
        handleSetRemoveKpi(chkBox, id);
    };
    const handleAllCheckboxChange = (e) => {
        const isChecked = e.target.checked; // Get the checked state of the "Select All" checkbox

        if (isChecked) {
            // If checked, select all backend variables
            const allBackendVariables = correlationData.filter((ele) => ele.containsNaN === false).map((datum) => datum.backendVariable);
            setSelectedBackendVariableForDriverAnalysis(allBackendVariables);
            setRemovedKpi(allBackendVariables)
        } else {
            // If unchecked, clear all selections
            setSelectedBackendVariableForDriverAnalysis([]);
            setRemovedKpi([])
        }
    };

    // Handle color range checkbox change
    const handleColorRangeChange = (rangeKey) => {
        setSelectedColorRanges((prev) => ({
            ...prev,
            [rangeKey]: !prev[rangeKey],
        }));
    };

    // Check if a value falls within selected ranges
    const isValueInSelectedRanges = (value) => {
        if (value === null || value === undefined || value === "NA" || value === "" || Number.isNaN(Number(value))) {
            return false; // NA values should not be filtered
        }

        const numValue = parseFloat(value);

        // Check each range to see if the value belongs to a selected range
        for (const range of colorRanges) {
            if (selectedColorRanges[range.key]) {
                if (numValue >= range.min && numValue <= range.max) {
                    return true;
                }
            }
        }
        return false;
    };

    const getProductData = (title, coreDataId) => {
        let url;
        if (isDeodorants) {
            url = process.env.REACT_APP_SERVER_PATH + `/products/?core_data_model=${coreDataId}&product_code=${encodeURIComponent(title)}`;
        } else if (isSkinCleansing) {
            url = process.env.REACT_APP_SERVER_PATH + `/skin-cleansing-products/?core_data_model=${coreDataId}&product_code=${encodeURIComponent(title)}`;
        } else if (isUnileverFragranceHouse) {
            url = process.env.REACT_APP_SERVER_PATH + `/unilever-fragrance-house-products/?core_data_model=${coreDataId}&product_code=${encodeURIComponent(title)}`;
        } else {
            url = process.env.REACT_APP_SERVER_PATH + `/oral-care-products/?core_data_model=${coreDataId}&product_code=${encodeURIComponent(title)}`;
        }
        try {
            api.get(url)
                .then(async (res) => {
                    if (res.data.length !== 0) {
                        setSelectedProductData(res.data[0]);
                    }
                    // handleProductDetailsDialogue();
                })
                .catch(async (error) => {
                    handleError("error", error);
                });
        } catch (error) {
            handleError("error", error);
        }
        const imageUrl = process.env.REACT_APP_SERVER_PATH + `/product-images/?core_data_model=${coreDataId}&product_code=${encodeURIComponent(title)}`;
        const imageBaseUrl = process.env.REACT_APP_MEDIA_PATH;
        try {
            api.get(imageUrl)
                .then(async (res) => {
                    if (process.env.REACT_APP_LOCAL_ENV === "True") {
                        setSelectedProductImage(res?.data?.[0]?.product_images || null);
                    } else {
                        if (res.data.length !== 0 && res.data[0].product_images.split("filestorage").length !== 0) {
                            const imagePath = imageBaseUrl + res.data[0].product_images.split(".unilever.com")[1];
                            setSelectedProductImage(imagePath);
                        } else {
                            setSelectedProductImage(null);
                        }
                    }
                })
                .catch(async (error) => {
                    handleError("error", error);
                });
        } catch (error) {
            handleError("error", error);
        }
        handleProductDetailsDialogue();
    };

    const handleProductDetailsDialogue = () => {
        setProductDetailsDialogueOpen(!productDetailsDialogueOpen);
    };

    const renderTableHead = () => {
        return (
            <tr>
                <th
                    style={{
                        minWidth: 300,
                        maxWidth: 300,
                        position: "sticky",
                        top: "0px", // Add this line
                        left: "0",
                        zIndex: 3,
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            height: "100%",
                            background: "#f0f8ff",
                            boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                            borderRadius: "5px",
                            padding: "5px",
                        }}
                    >
                        <div className={isBeautyAndWellbeing ? "table-seperator-col table-seperator-head-height table-seperator-col-hair-skin" : "table-seperator-col table-seperator-head-height"}></div>
                        <div
                            className="color-blue"
                            style={{
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            {correlationMethodLabel} Correlation Comparison Analysis
                        </div>
                    </div>
                </th>
                <th
                    className="checked--all_products_combined"
                    style={{
                        position: "sticky",
                        left: 300,
                        top: "0px",
                        zIndex: 3,
                        fontWeight: "600",
                        minWidth: 200,
                        maxWidth: 200,
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            height: "100%",
                        }}
                    >
                        <div className={isBeautyAndWellbeing ? "table-seperator-col table-seperator-head-height table-seperator-col-hair-skin" : "table-seperator-blue table-seperator-head-height"}></div>
                        <div
                            className="table-head-cell"
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            All Products Combined
                        </div>
                    </div>
                </th>
                {draggableColumns.map((datum, index) => {
                    // Check if the study is weighted
                    const isWeightedStudy = selectedStudy.some((study) => study.id === datum.coreDataId && study.weighted);
                    return (
                        <th
                            key={index}
                            draggable
                            onDragStart={(e) => handleColumnDragStart(e, index)}
                            onDragOver={handleDragOver}
                            onDrop={() => handleColumnDrop(index)}
                            align="center"
                            style={{
                                fontWeight: "600",
                                cursor: "move",
                                minWidth: targetColumnIndex === index && hasActuallyMoved ? draggedColumnDiamension.width : 200,
                                maxWidth: targetColumnIndex === index && hasActuallyMoved ? draggedColumnDiamension.height : 300,
                                position: "sticky",
                                top: 0,
                                zIndex: 2, // Ensure it stays on top of other elements
                                background: targetColumnIndex === index && hasActuallyMoved ? "#d8eeff" : "",
                            }}
                            className={!productColumnVisibility[`checked--${datum.title.split(" ").join("_")}__${datum.coreDataId}`] ? `checked--${datum.title.split(" ").join("_")}__${datum.coreDataId}` : `checked_${datum.title.replace(/\s+/g, "").toLowerCase()} hidden`}
                        >
                            {targetColumnIndex === index && hasActuallyMoved ? (
                                ""
                            ) : (
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        height: "100%",
                                    }}
                                >
                                    <div className={isBeautyAndWellbeing ? "table-seperator-col table-seperator-head-height table-seperator-col-hair-skin" : "table-seperator-blue table-seperator-head-height"}></div>
                                    <div
                                        className="table-head-cell"
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            flexDirection: "column",
                                        }}
                                    >
                                        <div
                                            style={{
                                                textAlign: "center",
                                            }}
                                        >
                                            {isWeightedStudy && ( // Render Bell icon if the study is weighted
                                                <NotificationsIcon
                                                    style={{
                                                        color: "#007BFF",
                                                        marginRight: 5,
                                                        verticalAlign: "middle",
                                                    }}
                                                    fontSize="small"
                                                />
                                            )}
                                            <span onClick={() => getProductData(datum.title, datum.coreDataId)}>
                                                {isOralCare ? (
                                                    <ProductWithTestCode
                                                        dragFlag={false}
                                                        selectedStudy={selectedStudy}
                                                        datum={datum}
                                                    />
                                                ) : (
                                                    <>
                                                        {datum.title} / {selectedStudy?.find((study) => study.id === datum.coreDataId)?.study_reference__title}
                                                    </>
                                                )}
                                            </span>
                                        </div>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                            }}
                                        >
                                            <SampleSizeNew
                                                productsSecondaryData={draggableColumns}
                                                productColumnVisibility={productColumnVisibility}
                                                productData={datum}
                                                pageName={"correlation"}
                                                sampleInfo={sampleInfo}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}
                        </th>
                    );
                })}
            </tr>
        );
    };

    const renderConsumerFilter = () => {
        return (
            <tr>
                <td
                    style={{
                        minWidth: 200,
                        maxWidth: 200,
                        position: "sticky",
                        left: 0,
                        zIndex: 2,
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            height: "100%",
                            background: "#fff",
                            boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                            borderRadius: "5px",
                            padding: "5px",
                        }}
                    >
                        <div className={isBeautyAndWellbeing ? "table-seperator-col table-seperator-row-height table-seperator-col-hair-skin" : "table-seperator-col table-seperator-row-height"}></div>
                        <div
                            className="table-body-cell"
                            style={{
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            {((role && role.toLowerCase() === "admin") || isBeautyAndWellbeing) && (
                                <>
                                    <input
                                        key="SelectAll"
                                        type="checkbox"
                                        id="SelectAll"
                                        className="custom_checkbox__input"
                                        onChange={handleAllCheckboxChange} // Use the updated function
                                        checked={selectedBackendVariableForDriverAnalysis.length === correlationData.filter((ele) => ele.containsNaN === false).length && selectedBackendVariableForDriverAnalysis.length !== 0} // Check if all are selected
                                        disabled={targetKpiNan}
                                    />
                                    <label
                                        htmlFor="SelectAll"
                                        style={{
                                            paddingTop: "2px",
                                            cursor: "pointer",
                                        }}
                                        className="custom_checkbox__label"
                                    >
                                        Select All
                                    </label>
                                </>
                            )}
                        </div>
                    </div>
                </td>
                <td
                    className="checked--all_products_combined"
                    style={{
                        minWidth: 200,
                        maxWidth: 200,
                        position: "sticky",
                        left: 300,
                        zIndex: 2,
                    }}
                >
                    <p></p>
                </td>
                {draggableColumns.length !== 0 &&
                    draggableColumns.map((datum, index) => (
                        <td
                            key={index}
                            align="center"
                            style={{
                                fontWeight: "500",
                                padding: "6px 0px",
                                background: targetColumnIndex === index && hasActuallyMoved ? "#d8eeff" : "",
                            }}
                            className={!productColumnVisibility[`checked--${datum.title.split(" ").join("_")}__${datum.coreDataId}`] ? `checked--${datum.title.split(" ").join("_")}__${datum.coreDataId}` : `checked_${datum.title.replace(/\s+/g, "").toLowerCase()} hidden`}
                        >
                            {targetColumnIndex === index && hasActuallyMoved ? (
                                ""
                            ) : (
                                <>
                                    {!isConsumerFilterLoadingStoreData ? (
                                        <CorrelationConsumerFilter
                                            productsSecondaryData={draggableColumns}
                                            product={datum}
                                            handleFilterSubmit={handleFilterSubmit}
                                            type="correlation"
                                        />
                                    ) : (
                                        <>
                                            <CircularProgress size={20} />
                                        </>
                                    )}
                                </>
                            )}
                        </td>
                    ))}
            </tr>
        );
    };

    // const renderSampleSize = () => {
    //     return (
    //         <tr>
    //             <td
    //                 style={{
    //                     minWidth: 300,
    //                     maxWidth: 300,
    //                     position: "sticky",
    //                     left: 0,
    //                     zIndex: 2,
    //                 }}
    //             ></td>
    //             <td
    //                 style={{
    //                     minWidth: 200,
    //                     maxWidth: 200,
    //                     position: "sticky",
    //                     left: 300,
    //                     zIndex: 2,
    //                 }}
    //             ></td>
    //             {/* {overallToggle ? (
    //                 <td
    //                     style={{ textAlign: "center" }}
    //                     colSpan={"1"}
    //                 >
    //                     <span
    //                         style={{
    //                             fontSize: "12px",
    //                             textAlign: "center",
    //                             fontWeight: "bold",
    //                         }}
    //                     >
    //                         <span style={{ color: overallColor }}>(n={totalSamplesize})</span>
    //                         <sup>
    //                             {totalSamplesize <= 50 && (
    //                                 <LightTooltip
    //                                     title={overallMsg || `Sample size is ${totalSamplesize}`}
    //                                     placement="right"
    //                                 >
    //                                     <InfoOutlinedIcon
    //                                         style={{
    //                                             fontSize: "11px",
    //                                             color: overallColor,
    //                                             cursor: "pointer",
    //                                         }}
    //                                     />
    //                                 </LightTooltip>
    //                             )}
    //                         </sup>
    //                     </span>
    //                 </td>
    //             ) : (
    //                 ""
    //             )} */}
    //             {draggableColumns.length !== 0 &&
    //                 draggableColumns.map((datum, index) => (
    //                     <td
    //                         key={index}
    //                         align="center"
    //                         style={{
    //                             fontWeight: "500",
    //                             padding: "6px 0px",
    //                             background: targetColumnIndex === index && hasActuallyMoved ? "#d8eeff" : "",
    //                         }}
    //                         className={!productColumnVisibility[`checked--${datum.title.split(" ").join("_")}__${datum.coreDataId}`] ? `checked--${datum.title.split(" ").join("_")}__${datum.coreDataId}` : `checked_${datum.title.replace(/\s+/g, "").toLowerCase()} hidden`}
    //                     >
    //                         {targetColumnIndex === index && hasActuallyMoved ? (
    //                             ""
    //                         ) : (
    //                             <>
    //                                 <SampleSizeNew
    //                                     productsSecondaryData={draggableColumns}
    //                                     productColumnVisibility={productColumnVisibility}
    //                                     // overallToggle={overallToggle}
    //                                     productData={datum}
    //                                     pageName={"correlation"}
    //                                     sampleInfo={sampleInfo}
    //                                 />
    //                             </>
    //                         )}
    //                     </td>
    //                 ))}
    //         </tr>
    //     );
    // };

    const getBackgroundColor = (correlationValue) => {
        if (correlationValue >= 0.7) {
            return "#008651";
        } else if (correlationValue >= 0.4 && correlationValue <= 0.69) {
            return "#A3E1D2";
        } else if (correlationValue >= 0.1 && correlationValue <= 0.39) {
            return "#FFE300";
        } else if (correlationValue >= 0 && correlationValue <= 0.09) {
            return "#FFA91F";
        } else if (correlationValue > -0.4 && correlationValue <= -0.01) {
            return "#FF9998";
        } else if (correlationValue >= -0.69 && correlationValue <= -0.4) {
            return "#FF544F";
        } else if (correlationValue <= -0.7) {
            return "#EB0000";
        }
    };

    const renderTableBody = () => {
        const row = correlationData.map((rowData, i) => {
            // let productsScoreWithNA = 0;

            const productRow = draggableColumns.map((pro, index) => {
                let products = rowData.products
                    ?.filter((ele) => `${ele.productCode.split(" ").join("_")}__${ele.coreDataId}` === `${pro.title.split(" ").join("_")}__${pro.coreDataId}`)
                    .map((datum) => {
                        const value = datum?.values?.[0];
                        // if (value === null || value === undefined || value === "" || value === "NA") {
                        //     productsScoreWithNA += 1;
                        // }

                        // Determine if this cell should show color based on selected ranges
                        const showColor = isBeautyAndWellbeing ? value !== null && value !== undefined && value !== "" && value !== "NA" && !Number.isNaN(Number(value)) && isValueInSelectedRanges(value) : true;

                        return (
                            <td
                                style={{
                                    backgroundColor: targetColumnIndex === index && hasActuallyMoved ? "#d8eeff" : "#fff",
                                    // backgroundColor: targetColumnIndex === index && hasActuallyMoved ? "#d8eeff" : value !== "" || value !== null || value !== undefined ? getBackgroundColor(value) : "#FFFFFF",
                                }}
                                key={index}
                                className={!productColumnVisibility[`checked--${datum.productCode.split(" ").join("_")}__${pro.coreDataId}`] ? `checked--${datum.productCode.split(" ").join("_")}__${pro.coreDataId}` : `checked_${datum.productCode.replace(/\s+/g, "").toLowerCase()} hidden`}
                            >
                                {targetColumnIndex === index && hasActuallyMoved ? (
                                    ""
                                ) : (
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            height: "100%",
                                        }}
                                    >
                                        <div className={isBeautyAndWellbeing ? "table-seperator-grey table-seperator-row-height table-seperator-grey-hair-skin" : "table-seperator-grey table-seperator-row-height"}></div>
                                        <div
                                            className="table-body-cell"
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                // Apply background color only if showColor is true, otherwise use white
                                                background: showColor && value !== "" && value !== null && value !== undefined ? getBackgroundColor(value) : "#FFFFFF",
                                                boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                                borderRadius: "5px",
                                                padding: "5px",
                                            }}
                                        >
                                            {isNaN(value) || value === "NA" || value === "" || value === null || value === undefined ? "NA" : parseFloat(value).toFixed(2)}
                                        </div>
                                    </div>
                                )}
                            </td>
                        );
                    });
                return products || [];
            });

            const allProductsCombined = rowData?.allProductsCombined?.[0];

            // Check if all products combined value should show color
            const showAllProductsColor = isBeautyAndWellbeing ? allProductsCombined !== null && allProductsCombined !== undefined && allProductsCombined !== "" && allProductsCombined !== "NA" && !Number.isNaN(Number(allProductsCombined)) && isValueInSelectedRanges(allProductsCombined) : true;

            const __row = (
                <tr key={i}>
                    <td
                        style={{
                            left: 0,
                            position: "sticky",
                            fontWeight: "600",
                            zIndex: 2,
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                height: "100%",
                                background: "#fff",
                                boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                borderRadius: "5px",
                                padding: "5px",
                            }}
                        >
                            <div className={isBeautyAndWellbeing ? "table-seperator-col table-seperator-row-height table-seperator-col-hair-skin" : "table-seperator-col table-seperator-row-height"}></div>

                            <div
                                className="table-body-cell"
                                style={{
                                    display: "flex",
                                }}
                            >
                                {((role && role.toLowerCase() === "admin") || isBeautyAndWellbeing || showCheckBox) ? (
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            padding: "5px",
                                        }}
                                    >
                                        <input
                                            key={rowData.backendVariable}
                                            type="checkbox"
                                            id={rowData.backendVariable}
                                            className="custom_checkbox__input"
                                            onChange={(e) => {
                                                handleCheckboxChange(e, rowData.backendVariable); // Update selected backend variable state
                                            }}
                                            checked={selectedBackendVariableForDriverAnalysis.includes(rowData.backendVariable)} // Bind checked state
                                            // disabled={disabledCheckboxes[rowData.backendVariable]} // Handle disabled state
                                            disabled={targetKpiNan || rowData.containsNaN} // Handle disabled state
                                        />
                                        <label
                                            htmlFor={rowData.backendVariable}
                                            style={{
                                                cursor: "pointer",
                                            }}
                                            className="custom_checkbox__label"
                                        >
                                            {rowData.displayLabel?.charAt(0).toUpperCase() + rowData.displayLabel?.slice(1) || ""}
                                            <span>&nbsp;</span> {/* Add space here */}
                                            <span
                                                style={{
                                                    color: VariableCategoryColorMap?.[rowData.macroCategory],
                                                }}
                                            >
                                                <em>{rowData.macroCategory}</em>
                                            </span>
                                        </label>
                                    </div>
                                ) : (
                                    <label>
                                        {rowData.displayLabel.charAt(0).toUpperCase() + rowData.displayLabel.slice(1)}
                                        <span>&nbsp;</span> {/* Add space here */}
                                        <span
                                            style={{
                                                color: VariableCategoryColorMap?.[rowData.macroCategory],
                                            }}
                                        >
                                            <em>{rowData.macroCategory}</em>
                                        </span>
                                    </label>
                                )}
                            </div>
                        </div>
                    </td>

                    <td
                        className="checked--all_products_combined"
                        style={{
                            left: 300,
                            position: "sticky",
                            textAlign: "center",
                            zIndex: 2,
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                height: "100%",
                            }}
                        >
                            <div className={isBeautyAndWellbeing ? "table-seperator-grey table-seperator-row-height table-seperator-grey-hair-skin" : "table-seperator-grey table-seperator-row-height"}></div>
                            <div
                                className="table-body-cell"
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    // Apply background color only if showAllProductsColor is true, otherwise use white
                                    background: showAllProductsColor && (allProductsCombined || Number(allProductsCombined) === 0 ) ? getBackgroundColor(allProductsCombined) : "#FFFFFF",
                                    boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                    borderRadius: "5px",
                                    padding: "5px",
                                }}
                            >
                                {(allProductsCombined || Number(allProductsCombined) === 0 ) ? (Number(allProductsCombined) === 0 ?((Object.is(Number(allProductsCombined), -0) ? "-0.00" : "0.00")): allProductsCombined) : "NA"}
                            </div>
                        </div>

                        {/* {isNaN(allProductsCombined) || allProductsCombined === "NA" || allProductsCombined === "" || allProductsCombined === null || allProductsCombined === undefined ? "NA" : parseFloat(allProductsCombined).toFixed(2)} */}
                    </td>
                    {productRow}
                </tr>
            );
            // if (productsScoreWithNA < noOfProducts) {
            //     if (removedList.includes(rowData.backendVariable)) {
            //         return;
            //     } else {
            //         return __row;
            //     }
            // } else {
            //     return;
            // }
            if (removedList.includes(rowData.backendVariable)) {
                return;
            } else {
                return __row;
            }
        });
        return row;
    };

    // column drag and drop logic
    // const handleColumnDragStart = (index) => {
    //     setDraggedColumnIndex(index);
    // };
    // const handleColumnDrop = (index) => {
    //     const updatedColumns = [...draggableColumns];
    //     const [draggedColumn] = updatedColumns.splice(draggedColumnIndex, 1);
    //     updatedColumns.splice(index, 0, draggedColumn);

    //     setDraggableColumns(updatedColumns);
    //     setDraggedColumnIndex(null);

    //     const _updateArray = updatedColumns.map((ele) => {
    //         return {
    //             productCode: ele.title,
    //             coreDataId: ele.coreDataId,
    //             isCompetitor: ele.isCompetitorProduct,
    //         };
    //     });
    //     dispatch(loadProductOrderState([..._updateArray]));
    // };

    // const handleDragOver = (event) => {
    //     event.preventDefault();
    // };

    const handleColumnDragStart = (e, index) => {
        e.dataTransfer.setData("columnIndex", index);
        // Create an invisible image to replace the default drag image
        const img = new Image();
        img.src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP88xIAAX8B5sR8D6cAAAAASUVORK5CYII=";
        e.dataTransfer.setDragImage(img, 0, 0);
        setDraggedColumnIndex(index);
        const headerRect = e.target.getBoundingClientRect();
        setMousePosition({
            x: e.clientX - dragOffset.x,
            y: e.clientY - dragOffset.y,
        });

        setDragOffset({
            x: e.clientX - headerRect.left,
            y: e.clientY - headerRect.top,
        });

        setDraggedColumnDiamension({
            width: headerRect.width,
            height: headerRect.height,
        });
        setIsDragging(true);
        initialMousePos.current = { x: e.clientX, y: e.clientY };
        setHasActuallyMoved(false);
    };

    const handleColumnDrop = (index) => {
        const updatedColumns = [...draggableColumns];
        const [draggedColumn] = updatedColumns.splice(draggedColumnIndex, 1);
        updatedColumns.splice(index, 0, draggedColumn);

        setDraggableColumns(updatedColumns);
        setDraggedColumnIndex(null);
        setIsDragging(false);

        const _updateArray = updatedColumns.map((ele) => {
            return {
                productCode: ele.title,
                coreDataId: ele.coreDataId,
                isCompetitor: ele.isCompetitorProduct,
            };
        });
        dispatch(loadProductOrderState([..._updateArray]));
        setHasActuallyMoved(false);
        setTargetColumnIndex(null);
        initialMousePos.current = null;
        setDraggedColumnDiamension({
            width: null,
            height: null,
        });
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        if (!isDragging) return;

        if (!hasActuallyMoved && initialMousePos.current) {
            const dx = Math.abs(e.clientX - initialMousePos.current.x);
            const dy = Math.abs(e.clientY - initialMousePos.current.y);
            if (dx > 5 || dy > 5) {
                setHasActuallyMoved(true);
            }
        }

        setMousePosition({
            x: e.clientX - dragOffset.x,
            y: e.clientY - dragOffset.y,
        });

        if (!hasActuallyMoved) return;

        const headers = Array.from(tableRef.current.querySelectorAll("th")).filter((header) => header.className.includes("checked--"));
        const draggedRect = draggedElementRef.current?.getBoundingClientRect();

        if (!draggedRect) return;

        const closestHeader = headers.reduce((closest, header, index) => {
            if (index === draggedColumnIndex) return closest;

            const rect = header.getBoundingClientRect();
            const center = rect.left + rect.width / 2;
            const distance = Math.abs(e.clientX - center);

            if (!closest || distance < closest.distance) {
                return { index, distance };
            }
            return closest;
        }, null);

        if (closestHeader) {
            if (draggedRect.left + draggedRect.width / 2 < headers[closestHeader.index].getBoundingClientRect().left + headers[closestHeader.index].getBoundingClientRect().width / 2) {
                if (hasActuallyMoved) {
                    setTargetColumnIndex(closestHeader.index);
                }
            }
        }
    };

    const clearAllDragVars = () => {
        setDraggedColumnIndex(null);
        setIsDragging(false);
        setHasActuallyMoved(false);
        setTargetColumnIndex(null);
        initialMousePos.current = null;
        setDraggedColumnDiamension({
            width: null,
            height: null,
        });
    };

    const renderDragTableBody = () => {
        const productData = draggableColumns[draggedColumnIndex];
        const row = correlationData.map((rowData, i) => {
            // let productsScoreWithNA = 0;

            const productRow = draggableColumns.map((pro, index) => {
                let products = rowData.products
                    ?.filter((ele) => ele.productCode === pro.title)
                    .map((datum) => {
                        const value = datum?.values?.[0];
                        // if (value === null || value === undefined || value === "" || value === "NA") {
                        //     productsScoreWithNA += 1;
                        // }

                        // Determine if this cell should show color based on selected ranges
                        const showColor = isBeautyAndWellbeing ? value !== null && value !== undefined && value !== "" && value !== "NA" && !Number.isNaN(Number(value)) && isValueInSelectedRanges(value) : true;

                        const _td = (
                            // <td
                            //     style={{
                            //         backgroundColor: targetColumnIndex === index && hasActuallyMoved ? "#d8eeff" : value !== "" || value !== null || value !== undefined ? getBackgroundColor(value) : "#FFFFFF",
                            //     }}
                            //     key={index}
                            //     className={!productColumnVisibility[`checked--${datum.productCode.split(" ").join("_")}__${pro.coreDataId}`] ? `checked--${datum.productCode.split(" ").join("_")}__${pro.coreDataId}` : `checked_${datum.productCode.replace(/\s+/g, "").toLowerCase()} hidden`}
                            // >
                            //     {targetColumnIndex === index && hasActuallyMoved ? "" : <>{isNaN(value) || value === "NA" || value === "" || value === null || value === undefined ? "NA" : parseFloat(value).toFixed(2)}</>}
                            // </td>
                            <td
                                style={{
                                    backgroundColor: targetColumnIndex === index && hasActuallyMoved ? "#d8eeff" : "#fff",
                                    // backgroundColor: targetColumnIndex === index && hasActuallyMoved ? "#d8eeff" : value !== "" || value !== null || value !== undefined ? getBackgroundColor(value) : "#FFFFFF",
                                }}
                                key={index}
                                className={!productColumnVisibility[`checked--${datum.productCode.split(" ").join("_")}__${pro.coreDataId}`] ? `checked--${datum.productCode.split(" ").join("_")}__${pro.coreDataId}` : `checked_${datum.productCode.replace(/\s+/g, "").toLowerCase()} hidden`}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        height: "100%",
                                    }}
                                >
                                    <div className={isBeautyAndWellbeing ? "table-seperator-grey table-seperator-row-height table-seperator-grey-hair-skin" : "table-seperator-grey table-seperator-row-height"}></div>
                                    <div
                                        className="table-body-cell"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            // Apply background color only if showColor is true, otherwise use white
                                            background: showColor && value !== "" && value !== null && value !== undefined ? getBackgroundColor(value) : "#FFFFFF",
                                            boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                            borderRadius: "5px",
                                            padding: "5px",
                                        }}
                                    >
                                        {isNaN(value) || value === "NA" || value === "" || value === null || value === undefined ? "NA" : parseFloat(value).toFixed(2)}
                                    </div>
                                </div>
                            </td>
                        );
                        return draggedColumnIndex === index ? _td : null;
                    })
                    .filter((ele) => ele);
                return products || [];
            });

            const __row = <tr key={i}>{productRow}</tr>;
            // if (productsScoreWithNA < noOfProducts) {
            //     if (removedList.includes(rowData.backendVariable)) {
            //         return;
            //     } else {
            //         return __row;
            //     }
            // } else {
            //     return;
            // }
            if (removedList.includes(rowData.backendVariable)) {
                return;
            } else {
                return __row;
            }
        });

        const _htmlRow = (
            <>
                {/* <tr>
                    <td
                        align="center"
                        style={{
                            fontWeight: "500",
                            padding: "6px 0px",
                        }}
                        className={!productColumnVisibility[`checked--${productData.title.split(" ").join("_")}__${productData.coreDataId}`] ? `checked--${productData.title.split(" ").join("_")}__${productData.coreDataId}` : `checked_${productData.title.replace(/\s+/g, "").toLowerCase()} hidden`}
                    >
                        <SampleSizeNew
                            productsSecondaryData={draggableColumns}
                            productColumnVisibility={productColumnVisibility}
                            productData={productData}
                            pageName={"correlation"}
                            sampleInfo={sampleInfo}
                        />
                    </td>
                </tr> */}
                <tr>
                    <td
                        key={productData.coreDataId}
                        align="center"
                        style={{
                            fontWeight: "500",
                            padding: "6px 0px",
                        }}
                        className={!productColumnVisibility[`checked--${productData.title.split(" ").join("_")}__${productData.coreDataId}`] ? `checked--${productData.title.split(" ").join("_")}__${productData.coreDataId}` : `checked_${productData.title.replace(/\s+/g, "").toLowerCase()} hidden`}
                    >
                        {!isConsumerFilterLoadingStoreData ? (
                            <CorrelationConsumerFilter
                                productsSecondaryData={draggableColumns}
                                product={productData}
                                handleFilterSubmit={handleFilterSubmit}
                            />
                        ) : (
                            <>
                                <CircularProgress size={20} />
                            </>
                        )}
                    </td>
                </tr>
                {row}
            </>
        );
        return _htmlRow;
    };

    // add remove kpi in table
    const handleSetRemoveKpi = (chkBox, value) => {
        let prevKpi = [...removedKpi];
        if (chkBox.target.checked) {
            prevKpi.push(value);
        } else {
            prevKpi = removedKpi?.filter((ele) => ele !== value);
        }
        setRemovedKpi(prevKpi);
    };

    const handleRemove = () => {
        // Check if there are any selected backend variables
        if (selectedBackendVariableForDriverAnalysis.length > 0) {
            // Store removed KPIs
            dispatch(loadCorrelationRemovedKpiListState([
            ...selectedBackendVariableForDriverAnalysis,
            ...removedList
            ]));
            // setRemovedKpi((prev) => [...prev, ...selectedBackendVariableForDriverAnalysis]); // Add selected variables to removedKpi
            setRestoreDisabled(false);
            setSelectedBackendVariableForDriverAnalysis([]);
        }
        if (showCheckBox) {
            setShowCheckBox(false);
        } else {
            setShowCheckBox(true);
        }
    };

    const handleSetRestoreKpi = (chkBox) => {
        let prevKpi = [...reStoreKpi];
        if (chkBox.target.checked) {
            if (chkBox.target.value === "All") {
                setRestoreKpi(removedList);
                setSelectAllRestore(true);
            } else {
                prevKpi.push(chkBox.target.value);
                setRestoreKpi(prevKpi);
                if (removedList.length === prevKpi.length) {
                    setSelectAllRestore(true);
                }
            }
            setDisableSubmitButton(false);
        } else {
            if (chkBox.target.value === "All") {
                setRestoreKpi([]);
                setDisableSubmitButton(true);
                setSelectAllRestore(false);
            } else {
                prevKpi = reStoreKpi?.filter((ele) => ele !== chkBox.target.value);
                setRestoreKpi(prevKpi);
                if (prevKpi.length === 0) {
                    setDisableSubmitButton(true);
                }
                setSelectAllRestore(false);
            }
        }
    };

    const handleRestoreVariables = () => {
        if (removedKpi.length === reStoreKpi.length) {
            dispatch(loadCorrelationRemovedKpiListState([]));
            setRemovedKpi([]);
            setRestoreDisabled(true);
        } else {
            const kpis = removedKpi.filter((ele) => !reStoreKpi.includes(ele));
            dispatch(loadCorrelationRemovedKpiListState(kpis));
            setRemovedKpi(kpis);
            if (kpis.length === 0) {
                setRestoreDisabled(true);
            }
        }
        setRestoreKpi([]);
        handleRestoreDialogClose();
        setSelectAllRestore(false);
    };

    const handleRestoreDialogClose = () => {
        setRestoreKpi([]);
        setSelectAllRestore(false);
        setOpenRestoreDialog(false);
    };

    const getDisplayLabels = (searchArr, kpi) => {
        let displayLabel = "";
        searchArr.forEach((datum) => {
            if (datum.backendVariable === kpi) {
                displayLabel = datum.displayLabel;
            }
        });

        return displayLabel;
    };

    const handleError = (type, error) => {
        dispatch(showNotification({ severity: type, data: error }));
    };

    const enrichedProductsForVisibility = draggableColumns.map(product => {
        const study = selectedStudy.find(s => s.id === product.coreDataId);
        return {
            ...product,
            study_reference_title: study?.study_reference__title || ''
        };
    });

    return (
        <div>
            <ColumnVisibility
                productsSecondaryData={enrichedProductsForVisibility}
                pageName="correlation"
                handleFilterSubmit={handleFilterSubmit}
            />
            <div
                style={{
                    // top: "-40px",
                    right: "-140px",
                    float: "right",
                    display: "inline-block",
                    position: "relative",
                }}
            >
                {/* <WeightToggleComponent /> */}
                <Button
                    size="small"
                    className={"custom-btn me-4 bold-content"}
                    disabled={true}
                    variant="outlined"
                    startIcon={
                        <img
                            className={"invert"}
                            style={{
                                height: "16px",
                            }}
                            src={WeightToggleIcon}
                        />
                    }
                >
                    Weight
                    <Switch
                        size="small"
                        disabled={true}
                        checked={false}
                        onChange={handleWeightToggleChange}
                    />
                </Button>
                <FilterAcrossProductsToggleComponent type="correlation" />
                <Button
                    size="small"
                    // className={!role || role === "user" ? "custom-btn me-3" : "custom-btn custom-btn-outlined color-blue me-3"}
                    className={"custom-btn custom-btn-outlined color-blue me-3 bold-content"}
                    // className={"me-3"}
                    variant="outlined"
                    onClick={() => navigate("/driver-analysis")}
                    startIcon={<AnalyticsIcon />}
                // disabled={!role || role === "user"}
                >
                    Show latest driver analysis report
                </Button>
                <DriverAnalysisFilters
                    selectedStudy={selectedStudy}
                    selectedBackendVariableForDriverAnalysis={selectedBackendVariableForDriverAnalysis}
                    targetKpi={targetKpi}
                    targetKpiLabel={targetKpiLabel}
                />
                <Reset
                    resetCorrelation={handleFilterSubmit}
                    setSelectedBackendVariableForDriverAnalysis={setSelectedBackendVariableForDriverAnalysis}
                    getDefaultCorrelationMethod={getDefaultCorrelationMethod}
                    setSelectedColorRanges={setSelectedColorRanges}
                    resetTargetVariable={resetTargetVariable}
                />
            </div>

            <div
                className="mb-1"
                style={{
                    display: "flex",
                    justifyContent: "space-evenly",
                    width: "100%",
                    fontWeight: "600",
                    paddingTop: 5,
                    position: "relative",
                    top: -25,
                }}
            >
                <p style={{ marginBottom: 0, color: "#495057" }}></p>
                <p style={{ marginBottom: 0, color: "#495057" }}></p>
            </div>
            <div
                className="table-responsive"
                style={{
                    position: "relative",
                    // maxHeight: "600px", // Set a maximum height for scrolling
                    minHeight: "calc(100vh - 400px)",
                    maxHeight: "calc(100vh - 400px)",
                    overflowY: "auto", // Enable vertical scrolling
                    overflowX: "auto", // Enable horizontal scrolling
                    width: "100%", // Ensure the table takes full width
                }}
            >
                <style>
                    {`
                    .analysis-table > :not(caption) > * > * {
                        border-bottom-width: 0px !important;
                    }
                    `}
                </style>
                <table
                    ref={tableRef}
                    className="table analysis-table text-xs"
                    style={{
                        background: "transparent",
                        marginBottom: 0,
                        width: "100%",
                    }}
                    onMouseLeave={clearAllDragVars}
                >
                    <thead>{renderTableHead()}</thead>
                    <tbody>
                        {/* {renderSampleSize()} */}
                        {renderConsumerFilter()}
                        {renderTableBody()}
                    </tbody>
                </table>
            </div>
            {/* <p style={{ fontSize: "14px", fontWeight: 600 }}>*NOTE: Select minimum 5 KPIs to perform Driver Analysis</p> */}
            <div className="d-flex">
                <span
                    style={{
                        fontSize: "12px",
                        color: "#495057",
                        margin: 10,
                        fontWeight: 600,
                    }}
                >
                    *NOTE: Select minimum 5 KPIs to perform Driver Analysis
                </span>
                {selectedBackendVariableForDriverAnalysis.includes("R_OO") && (
                    <span
                        style={{
                            fontSize: "12px",
                            color: "#ed6c02",
                            fontWeight: 600,
                            marginLeft: "auto",
                        }}
                    >
                        *&quot;Overall Opinion&quot; cannot be considered as an input variable for driver analysis
                    </span>
                )}
            </div>
            {selectedStudy.some((study) => study.weighted) && ( // Directly check for weight data
                <div
                    style={{
                        fontSize: "12px",
                        fontWeight: "600",
                        marginBottom: 5,
                        marginTop: "10px",
                    }}
                >
                    <span
                        style={{
                            color: "#007BFF",
                        }}
                    >
                        <NotificationsIcon
                            fontSize="small"
                            style={{
                                verticalAlign: "middle",
                            }}
                        />
                    </span>
                    <span
                        style={{
                            fontSize: "12px",
                            color: "#495057",
                            fontWeight: 600,
                            marginLeft: "auto",
                        }}
                    >
                        Certain product(s) belong to study(s) containing &apos;weight&apos; data, but &apos;weight&apos; is not considered for correlation.
                    </span>
                </div>
            )}
            {/* Added checkboxes to color legends and conditionally render based on category */}
            <ul style={{ display: "flex", justifyContent: "space-around", marginBottom: 0 }}>
                {colorRanges.map((range) => (
                    <li
                        key={range.key}
                        style={{ listStyle: "none", display: "flex", alignItems: "center" }}
                    >
                        {isBeautyAndWellbeing ? (
                            <label
                                style={{
                                    display: "inline-flex",
                                    alignItems: "stretch",
                                    cursor: "pointer",
                                    margin: 0,
                                    border: "1px solid #333",
                                    borderRadius: "4px",
                                    overflow: "hidden",
                                    userSelect: "none",
                                }}
                            >
                                <span
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        padding: "4px 8px",
                                        backgroundColor: "#fff",
                                    }}
                                >
                                    <input
                                        type="checkbox"
                                        checked={selectedColorRanges[range.key]}
                                        onChange={() => handleColorRangeChange(range.key)}
                                        style={{ cursor: "pointer", width: "15px", height: "15px", flexShrink: 0 }}
                                    />
                                </span>
                                <span
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        padding: "4px 12px",
                                        backgroundColor: range.color,
                                        color: ["#A3E1D2", "#FFE300", "#FFA91F", "#FF9998"].includes(range.color) ? "#333" : "#fff",
                                        fontSize: "14px",
                                        fontWeight: "500",
                                    }}
                                >
                                    {range.label}
                                </span>
                            </label>
                        ) : (
                            <>
                                <span
                                    style={{
                                        height: "15px",
                                        width: "15px",
                                        backgroundColor: range.color,
                                        display: "inline-block",
                                    }}
                                ></span>
                                <span style={{ padding: "8px", fontSize: "14px", fontWeight: "400" }}>{range.label}</span>
                            </>
                        )}
                    </li>
                ))}
            </ul>
            {isDragging && draggedColumnIndex !== null && hasActuallyMoved && (
                <div
                    ref={draggedElementRef}
                    style={{
                        position: "fixed",
                        zIndex: 1000,
                        pointerEvents: "none",
                        opacity: 1,
                        top: mousePosition.y,
                        left: mousePosition.x,
                        width: draggedColumnDiamension.width,
                        minHeight: draggedColumnDiamension.height,
                    }}
                >
                    <table
                        className="table analysis-table text-xs"
                        style={{
                            background: "white",
                            boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                            width: "100%",
                            height: draggedColumnDiamension.height,
                        }}
                    >
                        <thead>
                            <tr>
                                <th
                                    style={{
                                        fontWeight: "600",
                                        cursor: "move",
                                        minWidth: 200,
                                        maxWidth: 300,
                                    }}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            height: "100%",
                                        }}
                                    >
                                        <div className={isBeautyAndWellbeing ? "table-seperator-col table-seperator-head-height table-seperator-col-hair-skin" : "table-seperator-blue table-seperator-head-height"}></div>
                                        <div
                                            className="table-head-cell"
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                flexDirection: "column",
                                                textAlign: "center",
                                            }}
                                        >
                                            <div>
                                                {selectedStudy.some((study) => study.id === draggableColumns?.[draggedColumnIndex].coreDataId && study.weighted) && ( // Render Bell icon if the study is weighted
                                                    <NotificationsIcon
                                                        style={{
                                                            color: "#007BFF",
                                                            marginRight: 5,
                                                            verticalAlign: "middle",
                                                        }}
                                                        fontSize="small"
                                                    />
                                                )}
                                                <span onClick={() => getProductData(draggableColumns?.[draggedColumnIndex].title, draggableColumns?.[draggedColumnIndex].coreDataId)}>
                                                    {isOralCare ? (
                                                        <ProductWithTestCode
                                                            dragFlag={true}
                                                            selectedStudy={selectedStudy}
                                                            draggableColumns={draggableColumns}
                                                            draggedColumnIndex={draggedColumnIndex}
                                                        />
                                                    ) : (
                                                        <>
                                                            {draggableColumns?.[draggedColumnIndex].title} / {selectedStudy?.find((study) => study.id === draggableColumns?.[draggedColumnIndex].coreDataId)?.study_reference__title}
                                                        </>
                                                    )}
                                                </span>
                                            </div>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                <SampleSizeNew
                                                    productsSecondaryData={draggableColumns}
                                                    productColumnVisibility={productColumnVisibility}
                                                    productData={draggableColumns?.[draggedColumnIndex]}
                                                    pageName={"correlation"}
                                                    sampleInfo={sampleInfo}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>{renderDragTableBody()}</tbody>
                    </table>
                </div>
            )}

            <Box
                className=""
                sx={{
                    width: "100%",
                    textAlign: "left",
                    paddingBottom: "5px",
                }}
            >
                <Button
                    size="small"
                    className={"custom-btn liner-light-blue-background custom-btn--upload-reset"}
                    variant="contained"
                    onClick={handleRemove}
                >
                    Remove Variables
                </Button>
                <Button
                    size="small"
                    className={restoreDisabled ? "custom-btn custom-btn--upload-reset" : "custom-btn liner-light-blue-background custom-btn--upload-reset"}
                    variant="contained"
                    onClick={() => setOpenRestoreDialog(true)}
                    disabled={restoreDisabled}
                >
                    Restore Variables
                </Button>
            </Box>

            {productDetailsDialogueOpen && (
                <ProductDetails
                    productData={selectedProductData}
                    selectedProductImage={selectedProductImage}
                    open={productDetailsDialogueOpen}
                    closeBtn={
                        <IconButton
                            aria-label="close"
                            sx={{
                                position: "absolute",
                                right: 8,
                                top: 5,
                                color: "rgb(51, 94, 234) !important",
                            }}
                            size="small"
                            onClick={handleProductDetailsDialogue}
                        >
                            <CloseIcon />
                        </IconButton>
                    }
                />
            )}
            {openRestoreDialog && (
                <Dialog
                    open={openRestoreDialog}
                    onClose={handleRestoreDialogClose}
                    // aria-labelledby="alert-dialog-title"
                    // aria-describedby="alert-dialog-description"
                    fullWidth={true}
                    sx={{ "& .MuiDialog-paper": { width: "80%", minHeight: 300, maxHeight: 450 } }}
                    maxWidth="sm"
                >
                    <DialogTitle
                        style={{
                            backgroundColor: "rgb(51, 94, 234,0.1)",
                            color: "rgb(51, 94, 234)",
                            fontSize: 15,
                            textAlign: "center",
                            padding: "10px 12px",
                        }}
                        // className="liner-light-blue-background-2"
                        id="alert-dialog-title"
                    >
                        The following variables were removed from the Analysis :
                        <IconButton
                            aria-label="close"
                            sx={{
                                position: "absolute",
                                right: 8,
                                top: 2,
                                // fontSize: 10,
                                color: "rgb(51, 94, 234) !important",
                            }}
                            onClick={handleRestoreDialogClose}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        <div
                            style={{
                                minHeight: 150,
                                maxHeight: 350,
                                margin: "20px",
                                padding: "20px",
                            }}
                        >
                            <div>
                                <FormControlLabel
                                    sx={{
                                        "& .MuiTypography-root": {
                                            fontSize: 14,
                                            color: "#495057",
                                            padding: 0,
                                        },
                                        borderRadius: "5px",
                                        width: "100%",
                                        margin: "3px 0px",
                                        padding: "0px",
                                        color: selectAllRestore ? theme.palette.primary.main : theme.palette.text.primary,
                                        background: selectAllRestore ? "linear-gradient(270deg, rgb(0 103 239 / 0%) 0%, rgb(0 56 139 / 9%) 78%)" : "none",
                                    }}
                                    control={
                                        <Checkbox
                                            sx={{
                                                "& .MuiSvgIcon-root": {
                                                    fontSize: 18,
                                                },
                                                padding: "6px",
                                            }}
                                            color="secondary"
                                            checked={selectAllRestore ? true : false}
                                            onChange={handleSetRestoreKpi}
                                            value={"All"}
                                        // name={`${identifier}-${i}`}
                                        />
                                    }
                                    label={"Select All"}
                                />
                            </div>

                            <div
                                style={{
                                    marginLeft: 10,
                                }}
                            >
                                {removedList.map((datum, i) => {
                                    return (
                                        <FormControlLabel
                                            key={i}
                                            sx={{
                                                "& .MuiTypography-root": {
                                                    fontSize: 14,
                                                    color: "#495057",
                                                    padding: 0,
                                                },
                                                borderRadius: "5px",
                                                width: "100%",
                                                margin: "3px 0px",
                                                padding: "0px",
                                                color: reStoreKpi.includes(datum) ? theme.palette.primary.main : theme.palette.text.primary,
                                                background: reStoreKpi.includes(datum) ? "linear-gradient(270deg, rgb(0 103 239 / 0%) 0%, rgb(0 56 139 / 9%) 78%)" : "none",
                                            }}
                                            control={
                                                <Checkbox
                                                    sx={{
                                                        "& .MuiSvgIcon-root": {
                                                            fontSize: 18,
                                                        },
                                                        padding: "6px",
                                                    }}
                                                    color="secondary"
                                                    id={`${datum}-${i}`}
                                                    checked={reStoreKpi.includes(datum) ? true : false}
                                                    onChange={handleSetRestoreKpi}
                                                    value={datum}
                                                    name={`${datum}-${i}`}
                                                />
                                            }
                                            label={getDisplayLabels(correlationData, datum)}
                                        />
                                        // <div
                                        //     style={{
                                        //         display: "flex",
                                        //         alignItems: "center",
                                        //     }}
                                        //     key={i}
                                        // >
                                        //     <Checkbox
                                        //         sx={{
                                        //             "&.Mui-checked": {
                                        //                 color: "green",
                                        //             },
                                        //             "& .MuiSvgIcon-root": {
                                        //                 fontSize: 18,
                                        //             },
                                        //         }}
                                        //         color="secondary"
                                        //         checked={reStoreKpi.includes(datum) ? true : false}
                                        //         onChange={handleSetRestoreKpi}
                                        //         value={datum}
                                        //         // name={`${identifier}-${i}`}
                                        //     />
                                        //     <span>{getDisplayLabels(correlationData, datum)}</span>
                                        // </div>
                                    );
                                })}
                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            paddingBottom: "20px",
                        }}
                    >
                        <p
                            style={{
                                color: "#000000",
                                fontSize: "0.75rem",
                                fontWeight: "700",
                                margin: "0px 100px",
                                textAlign: "center",
                                paddingBottom: "20px",
                            }}
                        >
                            Are you sure you want to restore these variables?
                        </p>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            <Button
                                size="small"
                                className={"custom-btn custom-btn-outlined"}
                                variant="outlined"
                                onClick={handleRestoreDialogClose}
                                style={{
                                    margin: "5px 10px",
                                }}
                            >
                                No
                            </Button>
                            <Button
                                size="small"
                                className={disableSubmitButton ? "custom-btn  disabled" : "custom-btn custom-btn-outlined"}
                                variant="outlined"
                                onClick={handleRestoreVariables}
                                disabled={disableSubmitButton}
                                style={{
                                    margin: "5px 10px",
                                }}
                            >
                                Yes
                            </Button>
                        </div>
                    </DialogActions>
                </Dialog>
            )}
        </div>
    );
}

// Typechecking props for the OverallKpi
CorrelationTable.propTypes = {
    productsSecondaryData: PropTypes.array,
    handleFilterSubmit: PropTypes.func,
    correlationData: PropTypes.array,
    selectedStudy: PropTypes.array,
    targetKpi: PropTypes.string,
    targetKpiLabel: PropTypes.string,
    sampleInfo: PropTypes.object,
    targetKpiNan: PropTypes.bool,
    correlationMethodLabel: PropTypes.string,
    getDefaultCorrelationMethod: PropTypes.func,
    resetTargetVariable: PropTypes.func,
};
export default CorrelationTable;
